export class AnswerRequest {
    Question: string;
    UserEmail: string = '';
    ChatHistory: string;

    constructor(question: string, userEmail: string, chatHistory: string) {
        this.Question = question;
        this.UserEmail = userEmail;
        this.ChatHistory = chatHistory;
    }
}